import React from 'react';
import './CookieBannerContent.scss';
import CTAButton from '../../CTA/CTAButton/CTAButton';

/**
 * Renders the cookie banner content
 * @param {string} message
 * @param {function} clearState
 * @param {function} setState
 * @param {function} setConsent
 * @returns {JSX.Element}
 * @constructor
 */
const CookieBannerContent = ({ message, clearState, setState, setConsent }) => (
  <div className="c-cookie-banner-content">
    <div className="c-cookie-banner-content__inner">
      <div className="c-cookie-banner-content__left">
        <div
          className="c-cookie-banner-content__message body-3 color-black"
          dangerouslySetInnerHTML={{ __html: message }}
        ></div>
      </div>
      <div className="c-cookie-banner-content__right">
        <div className="c-cookie-banner-content__cta">
          <CTAButton
            isButton={true}
            onClick={() => {
              setState({
                isEntering: false,
                isExiting: true,
              });
              clearState();
              setConsent();
            }}
            link={'/cart'}
            type="primary"
            text={'Accept'}
            additionalClasses="cta color-white"
          />
        </div>
      </div>
    </div>
  </div>
);

export default CookieBannerContent;
